/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Prefs_TimezoneInputs */

const cs_settings_prefs_timezone = /** @type {(inputs: Settings_Prefs_TimezoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Časové pásmo`)
};

const en_settings_prefs_timezone = /** @type {(inputs: Settings_Prefs_TimezoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timezone`)
};

/**
* | output |
* | --- |
* | "Timezone" |
*
* @param {Settings_Prefs_TimezoneInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_prefs_timezone = /** @type {((inputs?: Settings_Prefs_TimezoneInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Prefs_TimezoneInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_prefs_timezone(inputs)
	return cs_settings_prefs_timezone(inputs)
});